import { useCallback, useRef, useState } from 'react';

import type { ToastItem } from '../components/ui/Toast.js';

let toastSeq = 0;

export function useToasts() {
  const [toasts, setToasts] = useState<ToastItem[]>([]);
  const timers = useRef<Record<string, ReturnType<typeof setTimeout>>>({});

  const dismiss = useCallback((id: string) => {
    setToasts(prev => prev.filter(t => t.id !== id));
    const timer = timers.current[id];
    if (timer) clearTimeout(timer);
    delete timers.current[id];
  }, []);

  const showToast = useCallback(
    (type: ToastItem['type'], message: string) => {
      const id = `toast-${++toastSeq}`;
      setToasts(prev => [...prev, { id, type, message }]);
      timers.current[id] = setTimeout(() => dismiss(id), 4000);
    },
    [dismiss],
  );

  return { toasts, showToast, dismiss };
}
